export default __webpack_public_path__ + "static/media/alien.d791a220.png";